<template>
    <div v-if="isUsingTablet || authBool">
        <v-text-field
            style="
                max-height: 0;
                opacity: 0;
                overflow: hidden;
                pointer-events: none;
            "
            v-model="scannerInput"
            id="scanner"
            @change="scannerInputChange"
        ></v-text-field>

        <div style="padding: 50px; background-color: white">
            <div style="width: 100%; display: flex; justify-content: space-between;">
                <div style="width: 250px;">
                    <v-select
                        label="Country Code"
                        :items="['FR', 'BR', 'US']"
                        v-model="selectedCountryCode"
                        variant="underlined"
                    ></v-select>
                </div>
                <div style="display: flex; justify-content: flex-end">
                    <v-btn
                        color="pink"
                        variant="elevated"
                        @click="focusOnScanner"
                        style="margin-right: 20px"
                    >
                        <v-icon
                            variant="elevated"
                            size="large"
                            icon="mdi:mdi-qrcode"
                        ></v-icon>
                    </v-btn>

                    <v-btn
                        v-if="authBool"
                        color="pink"
                        min-width="200"
                        variant="elevated"
                        @click="showMaterials"
                        style="margin-right: 20px"
                    >
                        <v-icon
                            variant="elevated"
                            size="large"
                            icon="mdi:mdi-magnify"
                        ></v-icon>
                        SEARCH MATERIALS
                    </v-btn>

                    <!-- <v-btn -->
                    <!-- color="pink" -->
                    <!-- min-width="200" -->
                    <!-- variant="elevated" -->
                    <!-- @click="focusOntextInput" -->
                    <!-- style="margin-right: 20px" -->
                    <!-- > -->
                    <!-- <v-icon -->
                    <!-- variant="elevated" -->
                    <!-- size="large" -->
                    <!-- icon="mdi:mdi-pencil" -->
                    <!-- ></v-icon> -->
                    <!-- TYPE IN MATERIAL -->
                    <!-- </v-btn> -->

                    <v-menu v-if="adminBool">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                color="pink"
                                variant="elevated"
                                style="margin-right: 20px"
                            >
                                Admin Actions
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-subheader>Material</v-list-subheader>
                            <!-- <v-list-item
                                @click="addMaterial"
                                prepend-icon="mdi:mdi-tray-arrow-up"
                                title="Add Material"
                                class="actions-list-item"
                            >
                            </v-list-item>

                            <v-list-item
                                v-if="selectedMaterial"
                                @click="editMaterial"
                                prepend-icon="mdi:mdi-pencil"
                                title="Edit Material"
                                class="actions-list-item"
                            >
                            </v-list-item>

                            <v-list-item
                                v-if="selectedMaterial"
                                @click="deleteMaterial(item)"
                                prepend-icon="mdi:mdi-alpha-x-circle"
                                title="Delete Material"
                                class="actions-list-item"
                                style="background-color: rgba(242, 121, 122, 0.4)"
                            >
                            </v-list-item>

                            <v-list-subheader>Vendor</v-list-subheader>
                            <v-list-item
                                @click="addVendor"
                                prepend-icon="mdi:mdi-tray-arrow-up"
                                title="Add Vendor"
                                class="actions-list-item"
                            >
                            </v-list-item> -->

                            <v-list-item
                                @click="showVendorList"
                                prepend-icon="mdi:mdi-view-list"
                                title="Vendor List"
                                class="actions-list-item"
                            >
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>

            <v-form @submit.prevent="searchForMaterial" :disabled="loading">
                <v-progress-circular
                    v-if="loading || scannerCount != scannerInput.length"
                    :size="120"
                    color="blue-lighten-3"
                    class="loading-spinner"
                    indeterminate
                    >Loading
                </v-progress-circular>

                <div
                    style="margin: auto; font-size: 15px; text-align: center"
                    v-if="boolFocusOnScanner == true"
                >
                    <label>Material UID or MID</label>
                    <h1>{{ form.search }}</h1>
                </div>
                <v-row
                    :style="
                        'display:flex;justify-content:center;' +
                        (screenType === 'mobile' ? '' : 'gap:25px;')
                    "
                >
                    <v-col cols="7">
                        <v-text-field
                            v-if="boolFocusOnScanner == false"
                            label="Material UID or MID"
                            id="searchField"
                            v-model="form.search"
                            variant="underlined"
                            color="primary"
                            :error-messages="errors['search']"
                            clearable
                            @clear="onClearClicked"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        v-if="boolFocusOnScanner == false"
                        :cols="screenType === 'mobile' ? '5' : '2'"
                        style="display: flex; align-items: center"
                    >
                        <v-btn
                            color="primary"
                            type="submit"
                            prepend-icon="mdi:mdi-magnify"
                            block
                        >
                            Search
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>

            <v-row
                style="display: flex; justify-content: center"
                v-if="selectedMaterial"
            >
                <v-col
                    :cols="screenType === 'mobile' ? '12' : '4'"
                    style="display: flex; align-items: center"
                >
                    <v-btn
                        color="primary"
                        type="button"
                        @click="checkinCheckoutOpen"
                        block
                    >
                        Checkin / Checkout
                    </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="selectedMaterial">
                <v-col cols="12">
                    <ViewMaterial :material="selectedMaterial" :materialId="null" />
                </v-col>
            </v-row>
        </div>

        <v-dialog v-model="dialogs.checkinCheckoutDialog" max-width="1000">
            <v-card>
                <v-card-text>
                    <CheckinCheckoutForm
                        @checkin-checkout-form-submit="
                            handleCheckinCheckoutFormSubmit
                        "
                        :material="selectedMaterial"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        block
                        @click="dialogs.checkinCheckoutDialog = false"
                        >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogs.addMaterialDialog" max-width="1000">
            <v-card>
                <v-card-text>
                    <AddMaterialForm
                        @create-material-form-submit="
                            handleCreateMaterialFormSubmit
                        "
                    />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        block
                        @click="dialogs.addMaterialDialog = false"
                        >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogs.editMaterialDialog" max-width="1000">
            <v-card>
                <v-card-text>
                    <EditMaterialForm
                        :materialId="selectedMaterial.id"
                        @update-material-form-submit="
                            handleUpdateMaterialFormSubmit
                        "
                    />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        block
                        @click="dialogs.editMaterialDialog = false"
                        >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogs.deleteMaterialDialog" max-width="1000">
            <v-card>
                <v-card-text>
                    <p
                        style="
                            text-align: center;
                            padding: 30px;
                            width: 100%;
                            font-weight: 600;
                        "
                    >
                        Are you sure you want to delete this material?
                        <span style="font-style: italic; font-weight: 400"
                            >({{ selectedMaterial.mid }})</span
                        >
                    </p>
                </v-card-text>
                <v-card-actions class="delete-material-actions">
                    <v-btn
                        color="primary"
                        class="close"
                        @click="dialogs.deleteMaterialDialog = false"
                        >Close
                    </v-btn>
                    <v-btn
                        color="danger"
                        class="delete"
                        @click="submitDeleteMaterial"
                        >Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogs.addVendorDialog" max-width="1000">
            <v-card>
                <v-card-text>
                    <CreateVendorForm
                        @create-material-vendor-form-submit="
                            handleCreateVendorFormSubmit
                        "
                    />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        block
                        @click="dialogs.addVendorDialog = false"
                        >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogs.vendorListDialog" max-width="1000">
            <v-card>
                <v-card-text>
                    <VendorList />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        block
                        @click="dialogs.vendorListDialog = false"
                        >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogs.showMaterialsDialog"
            transition="dialog-bottom-transition"
            fullscreen
        >
            <v-card>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        block
                        @click="dialogs.showMaterialsDialog = false"
                        >Close
                    </v-btn>
                </v-card-actions>
                <v-card-text>
                    <Materials />
                </v-card-text>
            </v-card>
        </v-dialog>

        <!------------------------------------------------------------------- SNACKBAR ALERT-->
        <v-snackbar v-model="showAlert" :timeout="5000">
            {{ alertText }}

            <template v-slot:actions>
                <v-btn color="blue" variant="text" @click="showAlert = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>

    <div v-else class="d-flex align-center justify-center">
        <v-row>
            <v-col cols="12" class="text-center pa-6">
                <span>User Must Log In To Access Matlabs</span>
                <br />
                <Link :href="route('login')">
                    <v-btn color="primary" class="mt-2">Return to login</v-btn>
                </Link>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";
import { Link } from "@inertiajs/inertia-vue3";
import ViewMaterial from "../../components/Design/ViewMaterial.vue";
import CheckinCheckoutForm from "../../components/Design/CheckinCheckoutForm.vue";
import GuestLayout from "../../Layouts/GuestLayout.vue";
import { useMaterials } from "../../stores/Design/Materials";
import { mapWritableState } from "pinia";

import { defineAsyncComponent } from "vue";
const AddMaterialForm = defineAsyncComponent(() =>
    import("../../components/Design/AddMaterialForm.vue")
);
const EditMaterialForm = defineAsyncComponent(() =>
    import("../../components/Design/EditMaterialForm.vue")
);
const CreateVendorForm = defineAsyncComponent(() =>
    import("../../components/Design/CreateVendorForm.vue")
);
const VendorList = defineAsyncComponent(() =>
    import("../../components/Design/VendorList.vue")
);
const Materials = defineAsyncComponent(() =>
    import("../../components/Design/Materials.vue")
);

export default {
    //  name: "MaterialLibrary",
    layout: [GuestLayout],
    components: {
        ViewMaterial,
        CheckinCheckoutForm,
        AddMaterialForm,
        EditMaterialForm,
        CreateVendorForm,
        VendorList,
        Materials,
        Link,
    },
    data() {
        return {
            scannerCount: 0,
            scannerInput: [],
            showAlert: false,
            alertText: null,
            selectedMaterial: null,
            boolFocusOnScanner: true,
            loading: false,
            authBool: false,
            adminBool: false,
            isUsingTablet: false,
            screenType: "desktop",
            form: {
                search: null,
            },
            dialogs: {
                imageDisplay: false,
                checkinCheckoutDialog: false,
                addMaterialDialog: false,
                editMaterialDialog: false,
                deleteMaterialDialog: false,
                addVendorDialog: false,
                vendorListDialog: false,
                showMaterialsDialog: false,
            },
            errors: {},
        };
    },
    async created() {
        this.selectedCountryCode = this.$page.props.auth.user ? `${this.$page.props.auth.user.countryCodeFK}`.trim() : 'US';
        this.fetchTabletBool();
        await this.checkLoginStatus();
        if (this.authBool) {
            await this.checkAdminStatus();
        }
    },
    async mounted() {
        if(this.isUsingTablet || this.authBool) {
            this.checkUrl();
            this.checkScreenWidth();
            this.focusOnScanner();
        }
    },
    computed: {
        ...mapWritableState(useMaterials, [
            "selectedCountryCode"
        ]),
        countryCode() {
            return this.selectedCountryCode ? this.selectedCountryCode : `${this.$page.props.auth.user.countryCodeFK}`.trim();
        },
    },
    methods: {
        focusOnScanner() {
            this.boolFocusOnScanner = true;
            this.scannerInput = [];
            document.getElementById("scanner").focus();
        },
        focusOntextInput() {
            this.boolFocusOnScanner = false;
        },
        checkScreenWidth() {
            let width = screen.width;
            if (width < 750) {
                this.screenType = "mobile";
            } else if (width < 1000) {
                this.screenType = "tablet";
            }
        },
        checkLoginStatus() {
            if (this.$page.props.auth.check) {
                this.authBool = true;
            }
        },
        checkUrl() {
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);

            let search = params.get("search");
            if (search) {
                this.form.search = search
                    .replace("%20", " ")
                    .replace(/['"]+/g, "");
                this.searchForMaterial();
            }
        },
        searchForMaterial() {
            this.loading = true;
            this.selectedMaterial = null;

            axios
                .post(route("api.materials.search"), this.form)
                .then((response) => {
                    this.loading = false;

                    if (Object.keys(response.data).length > 0) {
                        window.history.replaceState(
                            null,
                            null,
                            `?search=${this.form.search}`
                        );
                        this.selectedMaterial = response.data;
                        this.errors = {};
                        this.scannerInput = [];
                    } else {
                        this.selectedMaterial = null;
                        this.scannerInput = [];

                        this.errors["search"] = "Material not found";
                    }
                })
                .catch((obj) => {
                    this.loading = false;
                    this.scannerInput = [];
                    if (obj.response.status === 422) {
                        const errors = obj.response.data.errors;
                        Object.keys(errors).forEach((key) => {
                            console.log("error ", errors[key]);
                            this.errors[key] = errors[key];
                        });
                    }
                    if (obj.response.status === 400) {
                        this.errors["400"] = obj.response.data.message;
                    }
                });
        },
        checkinCheckoutOpen() {
            this.dialogs.checkinCheckoutDialog = true;
        },
        handleCheckinCheckoutFormSubmit(message) {
            this.dialogs.checkinCheckoutDialog = false;
            this.alertText = message;
            this.showAlert = true;
            this.searchForMaterial();
        },
        onClearClicked() {
            this.form.search = "";
            this.selectedMaterial = null;
        },
        scannerInputChange: debounce(function () {
            /**
             *  debounce function is typically used to delay the execution of a function until after a
             *  certain period of time has passed since the last invocation. This is useful when
             *  you want to handle an event like user input, but you want to wait for a short
             *  delay to ensure that the function is not called too frequently.
             */
            if (this.scannerInput.includes("/design/matlabs?search=")) {
                this.form.search = this.scannerInput.split("/matlabs?search=")[1].replace(/[^a-zA-Z0-9]/g, '');

                this.searchForMaterial();
            } else if (this.scannerInput.includes("Material_Library/vm.php?u=")) {
                this.form.search = this.scannerInput.split("Material_Library/vm.php?u=")[1].replace(/[^a-zA-Z0-9]/g, '');

                this.searchForMaterial();
            }
            this.testLab = this.scannerInput + " " + this.form.search;

            // document.getElementById("searchField").focus();
            this.focusOnScanner();
            this.scannerCount = this.scannerInput.length;
        }, 400),
        async checkAdminStatus() {
            let checkAdmin = axios.create({
                headers: {
                    username: this.$page.props.auth.user.username, //'micah.njibe',
                },
            });

            await checkAdmin
                .get(route("api.designer.show"))
                .then((response) => {
                    this.adminBool = response.data.admin == 1;
                })
                .catch((obj) => {
                    console.log("Err: ", obj);
                });
        },
        addMaterial() {
            this.dialogs.addMaterialDialog = true;
        },
        editMaterial() {
            this.dialogs.editMaterialDialog = true;
        },
        deleteMaterial() {
            this.dialogs.deleteMaterialDialog = true;
        },
        addVendor() {
            this.dialogs.addVendorDialog = true;
        },
        showVendorList() {
            this.dialogs.vendorListDialog = true;
        },
        showMaterials() {
            this.dialogs.showMaterialsDialog = true;
        },
        handleCreateMaterialFormSubmit(message) {
            this.dialogs.addMaterialDialog = false;
            this.alertText = message;
            this.showAlert = true;
        },
        handleUpdateMaterialFormSubmit(message) {
            this.dialogs.editMaterialDialog = false;
            this.alertText = message;
            this.showAlert = true;
        },
        handleCreateVendorFormSubmit(message) {
            this.dialogs.addVendorDialog = false;
            this.alertText = message;
            this.showAlert = true;
        },
        submitDeleteMaterial() {
            axios
                .post(route("api.materials.delete", this.selectedMaterial.id))
                .then((response) => {
                    this.dialogs.deleteMaterialDialog = false;
                    this.alertText = `Material deleted successfully!`;
                    this.showAlert = true;
                    this.fetchTableData();
                })
                .catch((obj) => {
                    if (obj.response.status === 422) {
                        const errors = obj.response.data.errors;
                        Object.keys(errors).forEach((key) => {
                            console.log(errors[key]);
                            this.errors[key] = errors[key];
                        });
                    }
                    if (obj.response.status === 400) {
                        this.errors["400"] = obj.response.data.message;
                    }
                });
        },
        fetchTabletBool() {
            this.isUsingTablet = false;
            const userAgent = navigator.userAgent.toLowerCase();
            const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            const tabletIdentifiers = [
                'ipad', 'android', 'silk', 'tablet', 'playbook', 'touch', 'kindle', 'nexus 7', 'nexus 10', 'sm-t', 'gt-p', 'lenovo', 'mediapad', 'xoom'
            ];

            for (let identifier of tabletIdentifiers) {
                if (userAgent.includes(identifier)) {
                    this.isUsingTablet = true;
                }
            }

            // Additional check for devices with larger screens and touch capabilities
            const screenWidth = window.screen.width;
            const screenHeight = window.screen.height;

            if (isTouchDevice && (screenWidth >= 600 && screenHeight >= 600)) {
                this.isUsingTablet = true;
            }
        },
    },
};
</script>
<style scoped>
.actions-list-item {
    cursor: pointer;
    transition: 0.3s all ease;
}

.actions-list-item:hover {
    background-color: rgb(231, 231, 231);
}

.delete-material-actions {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 20px;
}

.delete-material-actions button {
    width: 33%;
}

.delete-material-actions button.close:hover {
    background-color: rgba(201, 202, 206, 0.4);
}

.delete-material-actions button.delete:hover {
    background-color: rgba(242, 121, 122, 0.4);
}
</style>
